export default function pad_number_to_2_places(number) {
    return `${number}`.padStart(2, '0');
}

